import {AuthService} from "./auth";
import {httpConfiguratorService} from "./http";
import {CompaniesService} from "./companies";
import {PhotoTransformService} from "./photo-transform";
import {ToViewValueService} from "./configuration/to-view-value";
import {ToBoothValueService} from "./configuration/to-booth-value";
import ActiveService from "@/service.active";
import {EmailTemplateService} from "./configuration/email-template";
import {DetectChangesService} from "./configuration/detect-changes";
import {ToastService} from "./toast";
import {UndoDeleteService} from "./undo-delete";

let ServicesModule = angular.module("app.services", [])
	.service("$auth", AuthService)
	.service("$service", ActiveService)
	.service("$companies", CompaniesService)
	.service("$httpConfigurator", httpConfiguratorService)
	.service("$photoTransform", PhotoTransformService)
	.service("$ToViewValue", ToViewValueService)
	.service("$ToBoothValue", ToBoothValueService)
	.service("$EmailTemplates", EmailTemplateService)
	.service("$DetectChanges", DetectChangesService)
	.service("$ToastService", ToastService)
	.service("$UndoDeleteService", UndoDeleteService)
	.factory("$Company", ["$resource", ($resource) => $resource("/api/companies/:id/")])
	.factory("$Users", ["$resource", ($resource) => $resource("/api/users/:id/")])
	.factory("$Configuration", ["$resource", ($resource) => $resource("/api/configurations/:id/")])
	.factory("$Deployment", ["$resource", ($resource) => $resource("/api/deployments/:id/")])
	.factory("$Booth", ["$resource", ($resource) => $resource("/api/booths/:id/")])
	.factory("$SetConfigToBooth", ["$resource", ($resource) => $resource("/api/user-set-current-configuration-to-booth/")])
	.factory("$Version", ["$resource", ($resource) => $resource("/api/app-versions/")])
	.factory("$ApplyAppVersion", ["$resource", ($resource) => $resource("/api/booth-set-app-version/")])
    .factory("$ConfigMultiConfig", ["$resource", ($resource) => $resource("/api/configurations/:id/multi-config/")])
    .factory("$Forms", ["$resource", ($resource) => $resource("/api/forms/:id/")])
	.factory("$BoothList", ["$resource", ($resource) => $resource("/api/booth-list/")])
	.factory("$Invitations", ["$resource", ($resource) => $resource("/api/invitations/")])
	.factory("$RemoveBg", ["$resource", ($resource) => $resource("/api/configurations/:id/remove-bg/")])
	.factory("$Replicate", ["$resource", ($resource) => $resource("/api/configurations/:id/replicate-remove-bg/")]);


export { ServicesModule };



// WEBPACK FOOTER //
// ./sources/services/services.js